import { useCsrCmpSet } from "@/utils/csrCmpSet";
import commonCmpSet from "@/utils/brandCsrCmpSet/common";

// shopify
import CommerceAddToCart from "@/components/three-in-one/toshiba/shopify-component/add-to-cart/Index.vue";
import CommerceProductCheckout from "@/components/three-in-one/toshiba/shopify-component/checkout/Index.vue";
import tsbSearchResult from "@/components/three-in-one/toshiba/product/search-result/Index.vue";
import ProductList from "@/components/three-in-one/toshiba/product/product-list/v1/Index.vue";
import ProductBtnsV1 from "@/components/product/button/v1/Index.vue";
import toshibaSearchRecommendListv1 from  "@/components/three-in-one/toshiba/product/search-recommend-list/v1/Index.vue";
// shopify
import ProductVariantsV1 from "@/components/three-in-one/toshiba/product/variants/v1/Index.vue";
import CommerceProductPrice from "@/components/shopify-component/price/Index.vue";
import ProductBtns from "@/components/three-in-one/toshiba/product/button/v1/Index.vue";
import RelatedProduct from "@/components/three-in-one/toshiba/product/related-product/Index.vue";
import WishBtn from "@/components/three-in-one/toshiba/product/wish-btn/v1/Index.vue";
import CommerceProductShoppingCart from "@/components/three-in-one/toshiba/shopify-component/shoping-cart/Index.vue";
import toshibaCompare from "@/components/three-in-one/toshiba/compare/Index.vue";
import tsbWishList from "@/components/three-in-one/toshiba/wish-list/Index.vue";
import CommerceAccount from "@/components/three-in-one/toshiba/shopify-component/account/Index.vue";
import CommerceLogin from "@/components/three-in-one/toshiba/login/Index.vue";
import CartReminder from "@/components/three-in-one/toshiba/product/cart-reminder/Index.vue";
import {
  // shopify
  __CMP__COMMERCE_PRODUCT_CART__,
  __CMP__COMMERCE_PRODUCT_CHECKOUT__,
  __CMP__COMMERCE_PRODUCT_SHOPPING_CART__,
  __CMP_TOSHIBA_COMMERCE_ACCOUNT__,
  // product
  __CMP_TOSHIBA_PRODUCT_LIST__,
  __CMP_TSB_SEARCH_RESULT__,
  __CMP_PRODUCT_BTNS_V1__,
  __CMP_TOSHIBA_PRODUCT_BTNS__,
  __CMP_WISH_BTN__,
  __CMP__COMMERCE_PRODUCT_PRICE__,
  __CMP_TOSHIBA_COMPARE__,
  __CMP_TOSHIBA_RELATED_PRODUCT__,
  __CMP_TOSHIBA_WISH_LIST__,
  __CMP__COMMERCE_LOGIN__,
  __CMP_TOSHIBA_SEARCH_RECOMMEND_LIST_V1__,

  __CMP_PRODUCT_VARIANTS_V1__,
  __CMP_CART_REMINDER,
} from "@/const/csrCmpName.js";

const csrCmpSet = {
  ...commonCmpSet,
  // shopify
  [__CMP__COMMERCE_PRODUCT_CART__]: CommerceAddToCart,
  [__CMP__COMMERCE_PRODUCT_CHECKOUT__]: CommerceProductCheckout,
  [__CMP_TOSHIBA_COMMERCE_ACCOUNT__]: CommerceAccount,
  // product
  [__CMP_PRODUCT_BTNS_V1__]: ProductBtnsV1,
  [__CMP__COMMERCE_PRODUCT_PRICE__]: CommerceProductPrice,
  [__CMP_TSB_SEARCH_RESULT__]: tsbSearchResult,
  [__CMP_TOSHIBA_PRODUCT_LIST__]: ProductList,
  [__CMP_TOSHIBA_COMPARE__]: toshibaCompare,
  [__CMP_TOSHIBA_PRODUCT_BTNS__]: ProductBtns,
  [__CMP_TOSHIBA_RELATED_PRODUCT__]: RelatedProduct,
  [__CMP_WISH_BTN__]: WishBtn,
  [__CMP__COMMERCE_PRODUCT_SHOPPING_CART__]: CommerceProductShoppingCart,
  [__CMP_TOSHIBA_WISH_LIST__]: tsbWishList,
  [__CMP__COMMERCE_LOGIN__]: CommerceLogin,
  [__CMP_TOSHIBA_SEARCH_RECOMMEND_LIST_V1__]:toshibaSearchRecommendListv1,
  
  [__CMP_PRODUCT_VARIANTS_V1__]: ProductVariantsV1,
  [__CMP_CART_REMINDER]: CartReminder,
};

export default {
  csrCmpSet,
  ...useCsrCmpSet(csrCmpSet),
};
